window.addEventListener("DOMContentLoaded", () => {
    const productCardCarouselElement = document.querySelectorAll('.productCard-Carousel .swiper')

    if(productCardCarouselElement){

        const productCardCarousel = new Swiper('.productCard-Carousel .swiper', {
            slidesPerView: "auto",
            direction: 'horizontal',
            spaceBetween: 16,
            loop: false,
            
            pagination: {
                el: '.productCard-Carousel .swiper .swiper-pagination-fraction',
                type: "fraction",
            },
            
            navigation: {
                nextEl: '.productCard-Carousel .swiper .swiper-button-next',
                prevEl: '.productCard-Carousel .swiper .swiper-button-prev',
            },
            
        });

        const productCardCarouselProgress = new Swiper('.productCard-Carousel .swiper', {
            slidesPerView: "auto",
            direction: 'horizontal',
            spaceBetween: 16,
            loop: false,
            
            pagination: {
              el: '.productCard-Carousel .swiper .swiper-pagination-progress',
              type: "progressbar"
            },
          
        });

        productCardCarousel.controller.control = productCardCarouselProgress;

    }

})